/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import {
    BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar,
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../../utils/helpers';

const AmazonChannelbarChart = ({
    dir, data, height, index, channel, returnKey, currentlyShow
}) => {

    const [color1] = colorsCombination[(index + 1) % 10];
    const dataToPlot = []

    const dataByDay = {};

    data?.reduce(((acc, item) => {
        const key = returnKey({ item, currentlyShow });
        if (acc[key]) {
            acc[key].push(item)
        } else {
            acc[key] = [item]
        }
        return acc
    }), dataByDay);

    Object.keys(dataByDay).forEach((day) => {
        const dayData = dataByDay[day];
        const item = { day, Revenue: 0 };
        dayData.forEach((dayItem) => {
            item.Revenue += Number(dayItem.amount)
        })

        dataToPlot.push(item)
    })

    return (
        <Col xs={12} className=" mt-2 pt-3 container-create">
            <div className="card__title mb-2">
                <h5 className="bold-text">{channel}</h5>
            </div>
            <div dir="ltr">
                <ResponsiveContainer height={height}>
                    <BarChart
                        data={dataToPlot}
                        margin={{
                            top: 25, right: 0, left: 25, bottom: 0,
                        }}
                    >
                        <XAxis dataKey="day" reversed={dir === 'rtl'} />
                        <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                            tickFormatter={item => setCurrencyFormat(item, true)}
                            width={90}
                            allowDataOverflow
                        />
                        <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                        <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)} />
                        <Legend />
                        <Bar stackId="1" type="monotone" dataKey="Revenue" fill={color1 || '#3366ff'} />
                    </BarChart>
                </ResponsiveContainer>
            </div>

        </Col>
    );
};

AmazonChannelbarChart.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    height: PropTypes.number.isRequired,
    index: PropTypes.number,
    channel: PropTypes.string.isRequired,
    returnKey: PropTypes.func.isRequired,
    currentlyShow: PropTypes.objectOf({ key: "", value: "" }).isRequired
};

AmazonChannelbarChart.defaultProps = {
    index: 0
}

export default AmazonChannelbarChart;
